<template>
  <div class="auth">
    <NavBar />
    <div class="page-title"><h3>{{ t('account-title') }}</h3><CloseButton /></div>

    <form v-if="user" @submit.prevent="saveName">
      <label>{{ t('field-email') }}<input :value="user.email || t('account-no-email')" name="email" readonly /></label>
      <label>{{ t('field-display-name') }}<input v-model="displayName" name="displayName" /></label>
      <p v-if="nameMessage" :class="nameMessage.cls">{{ nameMessage.text }}</p>
      <button type="submit" :disabled="busy">{{ t('button-save') }}</button>
    </form>

    <!-- An account without email (e.g. created through WeChat) has no password either. -->
    <template v-if="user && user.email">
    <h4>{{ t('account-change-password') }}</h4>
    <form @submit.prevent="changePassword">
      <label>{{ t('field-current-password') }}<input v-model="current" type="password" name="currentPassword" autocomplete="current-password" /></label>
      <label>{{ t('field-new-password') }}<input v-model="password" type="password" name="password" autocomplete="new-password" /></label>
      <label>{{ t('field-password-again') }}<input v-model="password2" type="password" name="password2" autocomplete="new-password" /></label>
      <p v-if="passwordMessage" :class="passwordMessage.cls">{{ passwordMessage.text }}</p>
      <button type="submit" :disabled="busy">{{ t('button-save') }}</button>
    </form>
    </template>

    <component :is="section" v-for="(section, i) in sections" :key="i" />

    <button v-if="!hideSignOut" class="sign-out" @click="signOut">{{ t('button-sign-out') }}</button>
  </div>
</template>

<script>
import NavBar from './NavBar';
import CloseButton from './CloseButton';
import auth from '@/auth';
import extensions from '@/extensions';
import { t, errorText } from '@/texts';

export default {
  name: 'AccountPage',
  components: { NavBar, CloseButton },
  data() {
    const u = this.$store.state.user;
    return {
      sections: extensions.accountSections,
      hideSignOut: extensions.hideSignOut,
      displayName: u ? u.displayName : '',
      current: '', password: '', password2: '',
      nameMessage: null, passwordMessage: null, busy: false,
    };
  },
  computed: {
    user() { return this.$store.state.user; },
  },
  methods: {
    t,
    async saveName() {
      this.nameMessage = null;
      this.busy = true;
      try {
        await auth.setDisplayName(this.displayName);
        this.displayName = this.user.displayName;
        this.nameMessage = { cls: 'info', text: t('account-display-name-saved') };
      } catch (e) {
        this.nameMessage = { cls: 'warn', text: errorText(e.msg || String(e)) };
      } finally {
        this.busy = false;
      }
    },
    async changePassword() {
      this.passwordMessage = null;
      if (this.password !== this.password2) {
        this.passwordMessage = { cls: 'warn', text: t('error-passwords-differ') };
        return;
      }
      this.busy = true;
      try {
        await auth.changePassword(this.current, this.password);
        this.current = this.password = this.password2 = '';
        this.passwordMessage = { cls: 'info', text: t('account-password-changed') };
      } catch (e) {
        this.passwordMessage = { cls: 'warn', text: errorText(e.msg || String(e)) };
      } finally {
        this.busy = false;
      }
    },
    async signOut() {
      await auth.signOut();
      this.$router.replace({ name: 'root' });
    },
  },
};
</script>

<style src="./auth.css"></style>
<style scoped>
.sign-out {
  margin-top: 20px;
}

/* The email can't be changed here: shown as text, not as a field. */
.auth input[readonly] {
  height: auto;
  padding: 2px 0 8px;
  border: none;
  border-bottom: 1px solid #eee;
  border-radius: 0;
  color: #777;
  background: none;
}
</style>
